import { createSelector, createFeatureSelector } from '@ngrx/store';
import { EventsState } from '../reducers/calendar.reducer';

export const selectEventsState =
  createFeatureSelector<EventsState>('eventsData');

export const selectData = createSelector(
  selectEventsState,
  (state: EventsState) => state.data
);
